import { format, isValid } from 'date-fns';

type DateInput = string | Date | undefined | null;

export class DateFormatter {
    public static formatDate(dateInput?: DateInput) {
        if (!dateInput) {
            return 'N/A';
        }

        const date =
            dateInput instanceof Date ? dateInput : new Date(dateInput);

        // Guard against invalid dates (e.g., "foo", "", malformed strings, etc.)
        if (!isValid(date)) {
            return 'N/A';
        }

        return format(date, 'dd-MM-yyyy');
    }
}
